


























































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ExchangeRatesInjectorMixin from "@/mixins/exchangeRatesInjectorMixin";

@Component({
  components: {
    "exchange-rate-list-item": () =>
      import(
        "@/components/app/admin/settings/currencies/exchangeRateListItem.vue"
      )
  }
})
export default class InvoicesListing extends Mixins(
  ExchangeRatesInjectorMixin
) {
  public get skeletonSize() {
    const { data } = this.$exchangeRatesData.table;
    if (data.length) return data.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return (
      !this.$exchangeRatesData.isLoading &&
      !this.$exchangeRatesData.table.data.length
    );
  }

  public get showSkeletons() {
    return this.$exchangeRatesData.isLoading || !this.$exchangeRatesData.total;
  }
}
